import createOrUpdateFocusedOtherOverrideOperation from 'owa-service/lib/operation/createOrUpdateFocusedOtherOverrideOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
/**
 * Create or Update Focused Other override action service
 * @param senderSMTPAddress sender SMTP address
 * @param inferenceClassification the inferenceClassification
 * @return the CreateOrUpdateFocusedOtherOverrideResponse
 */
export function createOrUpdateFocusedOtherOverrideService(senderSMTPAddress, inferenceClassification) {
    var requestBody = {
        SenderSmtpAddress: senderSMTPAddress,
        AlwaysClassifyAs: inferenceClassification,
    };
    return createOrUpdateFocusedOtherOverrideOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
//# sourceMappingURL=createOrUpdateFocusedOtherOverrideService.js.map